import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';

import * as moment from 'moment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { PaymentsService } from 'src/app/modules/retailer/services/payments.service';

@Component({
  selector: 'app-regional-coupon-payments',
  templateUrl: './regional-coupon-payments.component.html',
  styleUrls: ['./regional-coupon-payments.component.scss']
})
export class RegionalCouponPaymentsComponent implements OnInit {

  public loginData: any;

  public paymentsFilter: any;
  public paymentsFilterNoOfDays: any = 0;
  public paymentsFilterLoading: boolean = false;
  public paymentsYear: any;
  public paymentsYearNoOfDays: any = 0;
  public paymentsYearLoading: boolean = false;

  public coupons: any = [];
  public couponsPageSize: number = 10;
  public couponsPage: number = 1;
  public couponsCount: number = 0;
  public couponsSortField: string = 'coupon_amount'; // Default sort by start date
  public couponsSortType: string = 'desc'; // Default sort ascending order
  public couponsLoading: boolean = false;

  public reportFilter: any;

  public couponPreviewData: any; // Coupon data for preview
  public couponPreviewModal: BsModalRef;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _paymentsService: PaymentsService,
    private _modalService: BsModalService,
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    this.getPaymentsData('filter'); // For filter date range
    this.getPaymentsData('year'); // For year

    this.couponsPage = 1; // Set defaults
    this.getCouponsPaymentsReport();
  }

  // Get coupon payments
  getPaymentsData(mode: string) {
    if (this.reportFilter) {
      let bodyStartDate: any;
      let bodyEndDate: any;

      if (mode == 'year') { // For this year
        this.paymentsYear = null;
        this.paymentsYearLoading = true;

        bodyStartDate = moment(moment().format("YYYY") + '-01-01').format('YYYY-MM-DD') + ' 00:00:00.000' // 12 AM
        bodyEndDate = moment().format('YYYY-MM-DD') + ' 23:59:59.000' // 11:59 PM

        // Find date difference
        this.paymentsYearNoOfDays = moment(moment(bodyEndDate).format('YYYY-MM-DD') + ' 24:00:00.000').diff(moment(moment(bodyStartDate).format('YYYY-MM-DD') + ' 00:00:00.000'), 'days');
      } else { // For filter  date
        this.paymentsFilter = null;
        this.paymentsFilterLoading = true;

        bodyStartDate = moment(this.reportFilter.date_range[0]).format('YYYY-MM-DD') + ' 00:00:00.000' // 12 AM
        bodyEndDate = moment(this.reportFilter.date_range[1]).format('YYYY-MM-DD') + ' 23:59:59.000' // 11:59 PM
      }

      let getCouponPaymentsBody = {
        provider_type: this.loginData.user_details.provider_type,
        provider_id: this.loginData.user_details.provider_id,
        retailer_id: this.loginData.user_details.provider_id,
        store_id: this.reportFilter.store,
        coupon_source: this.reportFilter.coupon_source,
        start_date: bodyStartDate,
        end_date: bodyEndDate
      };

      this._paymentsService.getCouponPayments(this.loginData.token, getCouponPaymentsBody).subscribe(async getCouponPaymentsResponse => {
        if (mode == 'year') { // For this year
          this.paymentsYearLoading = false;
        } else {
          this.paymentsFilterLoading = false;
        }

        if (getCouponPaymentsResponse.status === true) { // Success
          if (mode == 'year') { // For this year
            this.paymentsYear = getCouponPaymentsResponse;
          } else {
            this.paymentsFilter = getCouponPaymentsResponse;
          }
        } else {
          this._utilService.showToast(getCouponPaymentsResponse.message, '', 'error', {});
        }
      }, error => { // Error from getCouponPayments
        if (mode == 'year') { // For this year
          this.paymentsYearLoading = false;
        } else {
          this.paymentsFilterLoading = false;
        }
      });
    }
  }

  // Get coupons payments report
  getCouponsPaymentsReport() {
    if (this.reportFilter) {
      this.coupons = [];
      this.couponsCount = 0;
      this.couponsLoading = true;

      let getcouponsReportBody = {
        provider_type: this.loginData.user_details.provider_type,
        provider_id: this.loginData.user_details.provider_id,
        retailer_id: this.loginData.user_details.provider_id,
        store_id: this.reportFilter.store,
        coupon_source: this.reportFilter.coupon_source,
        start_date: moment(this.reportFilter.date_range[0]).format('YYYY-MM-DD') + ' 00:00:00.000', // 12 AM
        end_date:  moment(this.reportFilter.date_range[1]).format('YYYY-MM-DD') + ' 23:59:59.000', // 11:59 PM
        page: this.couponsPage,
        page_size: this.couponsPageSize,
        sort_field: this.couponsSortField,
        sort_type: this.couponsSortType,
      };

      this._paymentsService.getCouponsPaymentsReport(this.loginData.token, getcouponsReportBody).subscribe(async getCouponsPaymentsReportResponse => {
        this.couponsLoading = false;

        if (getCouponsPaymentsReportResponse.status === true) { // Success
          this.coupons = getCouponsPaymentsReportResponse.coupons;
          this.couponsCount = getCouponsPaymentsReportResponse.total_count;
        } else {
          this._utilService.showToast(getCouponsPaymentsReportResponse.message, '', 'error', {});
        }
      }, error => { // Error from getCouponsPaymentsReport
        this.couponsLoading = false;
      });
    }
  }

  // Coupons page change
  onCouponsPageChange(event: any) {
    this.couponsPage = event;
    this.getCouponsPaymentsReport();
  }

  // Coupons change sorting
  changeCouponsSorting(field: string) {
    if (this.coupons.length > 0) {
      if (this.couponsSortField == field) { // Same field - Change sort type
        if (this.couponsSortType == 'asc') {
          this.couponsSortType = 'desc';
        } else {
          this.couponsSortType = 'asc';
        }
      } else { // Different field - Set sort descending
        this.couponsSortType = 'desc';
      }

      this.couponsSortField = field;

      this.couponsPage = 1;
      this.getCouponsPaymentsReport();
    }
  }

  // On filter change
  async onfilterChange(event: any) {
    if (event.coupon_source == "national") {
      this._router.navigate(['/retailer/payments/national']); // Go to national payments
    } else {
      let isFirstCall: boolean = false;
      if (!this.reportFilter){
        isFirstCall = true;
      }

      this.reportFilter = event;

      if (isFirstCall || event.change =='store') {
        this.getPaymentsData('year'); // For year
      }
      this.getPaymentsData('filter'); // For filter date range

      // Find date difference
      this.paymentsFilterNoOfDays = moment(moment(this.reportFilter?.date_range[1]).format('YYYY-MM-DD') + ' 24:00:00.000').diff(moment(this.reportFilter?.date_range[0]).format('YYYY-MM-DD') + ' 00:00:00.000', 'days');

      this.couponsPage = 1;
      this.getCouponsPaymentsReport();
    }
  }

  // Show coupon preview modal
  async showCouponPreviewModal(coupon: any, template: TemplateRef<any>) {
    this.couponPreviewData = coupon;
    this.couponPreviewModal = this._modalService.show(template, {class: 'modal-lg'});
  }

  // Hide coupon preview modal
  hideCouponPreviewModal(): void {
    this.couponPreviewModal.hide();
  }

}
